import APIKit from "../Allapis/Apikit/apikit";

export const getConfigurations = async (id) => {
  console.log("API Called with id:", id);
  const endpoint = id ? `/configurations/${id}` : `/configurations`;
  console.log("Using endpoint:", endpoint);
  const res = await APIKit.get(endpoint);
  console.log("Response received:", res);
  return res.data;
};

export const updateConfigurations = async (id, values) => {
  const res = await APIKit.put(`/configurations/${id}`, values);
  console.log("Update Response:", res);
  return res.data;
};
